// extracted by mini-css-extract-plugin
export var deleteIcon = "_tb-5";
export var deleteOption = "_tb-3";
export var divider = "_tb-2";
export var downloadIcon = "_tb-4";
export var drawer = "_tb-0";
export var drawerFooter = "_tb-6";
export var drawerOpen = "_tb-1";
export var highlighted = "_tb-7";
export var lighterHighlight = "_tb-8";